import FormControl from '@material-ui/core/FormControl'
import styled, {createGlobalStyle} from 'styled-components'
import Select from 'lib/ui/Select'
import {onUnknownChangeHandler} from 'lib/dom'
import React from 'react'
import {Emoji as EmojiData} from 'Event/Dashboard/components/EmojiList/emoji'
import Option from 'lib/ui/Select/Option'

export default function EmojiSelect(props: {
  dark?: boolean
  value?: EmojiData['name']
  onPick: (emoji: string) => void
  emojis: EmojiData[]
  label?: string
}) {
  return (
    <>
      <EmojiSelectStyles />
      <FormControl fullWidth>
        <Select
          label={props.label ?? 'Pick an emoji'}
          aria-label="pick emoji"
          menuClassName="emoji-select"
          value={props.value}
          fullWidth
          onChange={onUnknownChangeHandler(props.onPick)}
        >
          {props.emojis.map((emoji, index) => {
            return (
              <Option
                key={index}
                value={emoji.name}
                dark={props.dark}
                className="emoji-option"
              >
                <Emoji emoji={emoji} />
              </Option>
            )
          })}
        </Select>
      </FormControl>
    </>
  )
}

function Emoji(props: {emoji: EmojiData}) {
  const {emoji} = props

  if (emoji.icon) {
    return <EmojiIcon>{emoji.icon}</EmojiIcon>
  }

  if (emoji.image) {
    return <Image src={emoji.image} alt={emoji.name} />
  }

  return null
}

const Image = styled.img`
  height: 25px;
`

const EmojiIcon = styled.span`
  font-size: 25px;
  height: 25px;
  display: flex;
  align-items: center;
`

const EmojiSelectStyles = createGlobalStyle`
  .emoji-select ul {
    display: grid !important;
    grid-template-columns: repeat(auto-fill, minmax(48px, 1fr));
    gap: 8px;
    padding: 8px;
    max-height: 250px;
  }

`
